import { cn } from '@ui/lib/utils'
import NextImage from 'next/image'

interface AvatarProps {
  src?: string | null
  alt?: string
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl' | 'xxl' | 'xxxl'
  fallback?: string
  className?: string
}

const sizeClasses = {
  xs: 'w-6 h-6 text-xs',
  sm: 'w-8 h-8 text-sm',
  md: 'w-10 h-10 text-base',
  lg: 'w-12 h-12 text-lg',
  xl: 'w-16 h-16 text-xl',
  xxl: 'w-20 h-20 text-2xl',
  xxxl: 'w-24 h-24 text-3xl',
}

const getImageUrl = (imageUrl: string, defaultImage: string) => {
  return imageUrl ? `${imageUrl}` : defaultImage;
};

export function Avatar({ src, alt = 'Avatar', size = 'md', fallback, className }: AvatarProps) {
  const initials = fallback || alt.charAt(0).toUpperCase()

  return (
    <div
      className={cn(
        'relative inline-flex items-center justify-center rounded-full overflow-hidden bg-gray-200 text-gray-600 font-medium',
        sizeClasses[size],
        className
      )}
    >
      {src ? (
        <NextImage
          unoptimized
          src={getImageUrl(src, 'avatar.png')}
          alt={alt}
          fill
          className="object-cover"
          sizes={size === 'xl' ? '64px' : size === 'lg' ? '48px' : size === 'md' ? '40px' : '32px'}
        />
      ) : (
        <span>{initials}</span>
      )}
    </div>
  )
}
